import React, { useRef, useState } from 'react';
import { View, Animated, StatusBar } from 'react-native';
import { connect } from 'react-redux';

import AnimatedHeader from '@components/common/AnimatedHeader';

import { scale, width } from '@components/frame';
import { isWeb, isPhone, isAndroid } from '@helpers';

import ColorWrapper from '@styles/colors';
import { getAllFeatureFlags } from '@reducers/user';

import Details from './components/details';

const Environment = (props) => {
  const { C } = props;
  const [headerActive, setHeaderActive] = useState(false);

  const fadeAnim = useRef(new Animated.Value(0)).current;
  const scrollRef = useRef(null);

  const startFrom = 30;

  const scrollListener = ({ nativeEvent }) => {
    const {
      contentOffset: { y },
    } = nativeEvent;

    if (isAndroid) {
      if (y > scale(startFrom)) {
        if (!headerActive) {
          setHeaderActive(true);
          StatusBar.setBackgroundColor(C('Background / Light / System'));
        }
      } else {
        if (headerActive) {
          setHeaderActive(false);
          StatusBar.setBackgroundColor(C('Background/Light/Detail'));
        }
      }
    }
  };

  return (
    <View style={{ width: '100%', height: '100%', backgroundColor: C('Background/Light/Detail'), alignItems: 'center' }} key="AccoutDetails">
      <View style={{ width, height: '100%', alignContent: 'center', paddingTop: isWeb ? scale(30) : 0 }}>
        <AnimatedHeader
          {...{
            fadeAnim,
            C,
            scrollRef,
            startFrom: -1000,
            startBGFrom: 15,
            back: true,
            backText: isPhone ? ' ' : 'Environment',
            text: 'Feature Level Development',
          }}
        />
        <Animated.ScrollView
          scrollEventThrottle={16}
          ref={scrollRef}
          onScroll={Animated.event([{ nativeEvent: { contentOffset: { y: fadeAnim } } }], {
            useNativeDriver: false,
            listener: scrollListener,
          })}
          style={{
            width: '100%',
          }}
          contentContainerStyle={{ paddingBottom: scale(50), width: '100%' }}
        >
          <View style={{ width: '100%', height: scale(44), alignItems: 'center', justifyContent: 'center', marginTop: scale(16) }}></View>
          <View
            style={{
              paddingHorizontal: scale(isPhone ? 15 : 195),
            }}
          >
            <Details {...props} />
          </View>
        </Animated.ScrollView>
      </View>
    </View>
  );
};

export default connect(({ user }) => ({ user }), { getAllFeatureFlags })(ColorWrapper(Environment));
